module.exports = __webpack_public_path__ + "static/img/operingManagement.f6d52da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/operingManagement.png
// module id = BLhZ
// module chunks = 1